<div [attr.data-automation]="config.dataAutomation">
  <h5>
    @if (state.required) {
      <span class="text-danger ziro-forms-asterisk">*</span>
    }
    <span [innerHTML]="getLabel() | escapeHtml"></span>
  </h5>
  <div class="align-items-center d-flex group-item-text-wrapper">
    <div class="general-settings-select__content" [innerHTML]="config.options?.content | escapeHtml"></div>
    <div class="general-settings-select__input">
      <div
        class="mb-3 row"
        [hidden]="state.hidden"
        [attr.data-automation]="config.dataAutomation + '-select'"
        [ngClass]="{
          'has-feedback': showValidation || isFormSubmitted,
          'ziro-forms-error': validationState === ValStates.INVALID,
          'ziro-forms-warning': validationState === ValStates.PENDING || validationState === ValStates.WARNING,
          'ziro-forms-success': validationState === ValStates.VALID && showAsyncValidation,
        }"
      >
        <div class="col">
          <div class="input-group">
            <ng-select
              class="w-100"
              [labelForId]="config.dataAutomation + '-select'"
              [attr.data-automation]="'ziro-select-input'"
              [bindLabel]="'label'"
              [(ngModel)]="fieldData"
              [items]="options"
              #ngModelDir="ngModel"
              (ngModelChange)="updateStateAndSelf($event, ngModelDir)"
              [disabled]="state.disabled"
              [clearable]="false"
            ></ng-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
